const GET_ACCOUNTING_GROUPS = "GET_ACCOUNTING_GROUPS";
const GET_ADHESIVES = "GET_ADHESIVE";
const GET_AMALGAM_CODE = "GET_AMALGAM_CODE";
const GET_BOTTLINGS = "GET_BOTTLINGS";
const GET_BOTTLE_SIZES = "GET_BOTTLE_SIZE";
const GET_BOTTLES_PER_UNITS = "GET_BOTTLES_PER_UNIT";
const GET_BRANDS = "GET_BRANDS";
const GET_BRAND_OWNERS = "GET_BRAND_OWNERS";
const GET_BUYERS = "GET_BUYERS";
const GET_CAPSULE_QUALITIES = "GET_CAPSULE_QUALITIES";
const GET_CARTON_EXTERNAL_BOARDS = "GET_CARTON_EXTERNAL_BOARDS";
const GET_CARTON_PRINTINGS = "GET_CARTON_PRINTINGS";
const GET_CARTON_TYPES = "GET_CARTON_TYPES";
const GET_CUSTOMS_TYPES = "GET_CUSTOMS_TYPES";
const GET_CERTIFICATIONS = "GET_CERTIFICATIONS";
const GET_DECORATION_TYPES = "GET_DECORATION_TYPES";
const GET_GIFT_BOX_TYPES = "GET_GIFT_BOX_TYPE";
const GET_GLASS_HUES = "GET_GLASS_HUES";
const GET_GL_KEYS = "GET_GL_KEYS";
const GET_ITEM_CHARACTERISTICS = "GET_ITEM_CHARACTERISTICS";
const GET_ITEM_MASTERS = "GET_ITEM_MASTERS";
const GET_ITEM_SUPPLEMENTAL_DATA = "GET_ITEM_SUPPLEMENTAL_DATA";
const GET_ITEM_TYPES = "GET_ITEM_TYPES";
const GET_LABEL_TYPES = "GET_LABEL_TYPES";
const GET_LEVEL2_CLASSIFICATIONS = "GET_LEVEL2_CLASSIFICATIONS";
const GET_LEVEL3_CLASSIFICATIONS = "GET_LEVEL3_CLASSIFICATIONS";
const GET_MAIN_LOCATIONS = "GET_MAIN_LOCATIONS";
const GET_MARKET_VALIDATORS = "GET_MARKET_VALIDATORS";
const GET_MASTER_PLANNING_FAMILY = "GET_MASTER_PLANNING_FAMILY";
const GET_MATERIALS = "GET_MATERIALS";
const GET_MEASURE_UNIT = "GET_MEASURE_UNIT";
const GET_ORIGIN_COUNTRIES = "GET_ORIGIN_COUNTRIES";
const GET_PACKAGINGS = "GET_PACKAGINGS";
const GET_PROCUREMENT_OFFICERS = "GET_PROCUREMENT_OFFICERS";
const GET_PRODUCT_TYPES = "GET_PRODUCT_TYPES";
const GET_PURCHASE_ORDERS = "GET_PURCHASE_ORDERS";
const GET_PURCHASING_FAMILY = "GET_PURCHASING_FAMILY";
const GET_PURCHASING_SUB_FAMILY = "GET_PURCHASING_SUB_FAMILY";
const GET_QUALITIES = "GET_QUALITIES";
const GET_SINGLE_ITEM_MASTER = "GET_SINGLE_ITEM_MASTER";
const GET_LINEARS = "GET_LINEAR";
const GET_SUB_MATERIALS = "GET_SUB_MATERIAL";
const GET_SUPPLIERS = "GET_SUPPLIERS";
const GET_USER_DEFINED_CODES = "GET_USER_DEFINED_CODES";
const GET_VAP_CODE = "GET_VAP_CODE";
const GET_VINTAGES = "GET_VINTAGES";
const GET_WAREHOUSE_CODES = "GET_WAREHOUSE_CODES";
const RESET_STATE = "RESET_STATE";

export {
    GET_ACCOUNTING_GROUPS,
    GET_ADHESIVES,
    GET_AMALGAM_CODE,
    GET_BOTTLE_SIZES,
    GET_BOTTLES_PER_UNITS,
    GET_BOTTLINGS,
    GET_BRANDS,
    GET_BRAND_OWNERS,
    GET_BUYERS,
    GET_CAPSULE_QUALITIES,
    GET_CARTON_EXTERNAL_BOARDS,
    GET_CARTON_PRINTINGS,
    GET_CARTON_TYPES,
    GET_CERTIFICATIONS,
    GET_CUSTOMS_TYPES,
    GET_DECORATION_TYPES,
    GET_GIFT_BOX_TYPES,
    GET_GLASS_HUES,
    GET_GL_KEYS,
    GET_ITEM_CHARACTERISTICS,
    GET_ITEM_MASTERS,
    GET_ITEM_SUPPLEMENTAL_DATA,
    GET_ITEM_TYPES,
    GET_LABEL_TYPES,
    GET_LEVEL2_CLASSIFICATIONS,
    GET_LEVEL3_CLASSIFICATIONS,
    GET_LINEARS,
    GET_MAIN_LOCATIONS,
    GET_MARKET_VALIDATORS,
    GET_MASTER_PLANNING_FAMILY,
    GET_MATERIALS,
    GET_MEASURE_UNIT,
    GET_ORIGIN_COUNTRIES,
    GET_PACKAGINGS,
    GET_PROCUREMENT_OFFICERS,
    GET_PRODUCT_TYPES,
    GET_PURCHASE_ORDERS,
    GET_PURCHASING_FAMILY,
    GET_PURCHASING_SUB_FAMILY,
    GET_QUALITIES,
    GET_SINGLE_ITEM_MASTER,
    GET_SUB_MATERIALS,
    GET_SUPPLIERS,
    GET_USER_DEFINED_CODES,
    GET_VAP_CODE,
    GET_VINTAGES,
    GET_WAREHOUSE_CODES,
    RESET_STATE,
};
